/* eslint-disable react/jsx-props-no-spreading */
import { Button, ButtonProps, Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import * as React from 'react';
import { DropEvent, useDropzone } from 'react-dropzone';
import { Text } from 'vet-bones/components';

import { FileExtension } from 'src/constants/fileExtensions';
import { TEST_IDS } from 'src/constants/testIds';
import * as copy from 'src/templates/copy';

type DropzoneProps = {
  acceptTypes: FileExtension | FileExtension[];
  disabled?: boolean;
  multiple?: boolean;
  onDropAccepted: (files: File[], event: DropEvent) => void;
  text?: string;
  ellipsize?: boolean;
  buttonProps?: ButtonProps;
  buttonTestId?: string;
};

export const Dropzone: React.VFC<DropzoneProps> = ({
  acceptTypes,
  disabled,
  multiple = false,
  onDropAccepted,
  text,
  ellipsize,
  buttonProps,
  buttonTestId,
}) => {
  const { getInputProps, getRootProps, open } = useDropzone({
    accept: acceptTypes,
    disabled,
    multiple,
    noClick: true,
    noKeyboard: true,
    onDropAccepted,
  });

  const allButtonProps = {
    ...(buttonProps || {}),
    'data-testid': buttonTestId,
    disabled,
    onClick: open,
    ref: React.useRef<Button>(null),
    text: buttonProps?.text || copy.components.dropzone.browse,
  };

  return (
    <div
      {...getRootProps({ className: 'sd-dropzone' })}
      data-testid={TEST_IDS.dropzone.container}
    >
      <div className="sd-dropzone-icon">
        <Icon icon={IconNames.UPLOAD} iconSize={24} />
      </div>
      <div className="sd-dropzone-input">
        <input {...getInputProps()} data-testid={TEST_IDS.dropzone.fileInput} />
        <Text className="sd-dropzone-text" ellipsize={ellipsize}>
          {text || copy.components.dropzone.drag}
        </Text>
        <Button {...allButtonProps} />
      </div>
    </div>
  );
};
